import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["partners", "partnerInfo", "partnerSelect", "partnerCard"];

  choosePartner() {
    this.partnersTarget.classList.add("show");
    this.partnerInfoTarget.classList.remove("show");
  }

  connect() {
    this.initSelect();
  }

  initSelect() {
    const select = $(this.partnerSelectTarget);

    select.select2({
      width: "100%",
      theme: "novem"
    });
    select.on("select2:open", function() {
      $("input.select2-search__field").attr("placeholder", window.i18n.t("view.contract_controller.find_partners"));
    });
    select.on("select2:select", (e) => {
      this.loadPartnerCard( e.params.data.id);
    });
  }
  async loadPartnerCard(id) {
    if (id) {
      this.partnerCardTarget.innerHTML = await fetch(`/admin/partners/${id}/card`)
        .then(response => response.text())
        .then(html => { return html; });
    } else {
      this.partnerCardTarget.innerHTML = "";
    }
  }

}
